/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Entry/view.blocks to change it.
import * as fromAggregate from 'Data/aggregate.js'
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFlow from 'Simple/Flow'
import * as fromFormat from 'Data/format.js'
import * as fromHelpers from './helpers.js'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Entry({
  children,
  viewPath = "/DesignSystem/PatientInformation/Content/AppointmentBooking/Content/AppointmentHistory/Timeline/Content/Entry"
  
}) {
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let dtSpaceLs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.ls'
        })
let dtColorsNeutral200 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.200'
        })
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let dtColorsNeutral400 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.400'
        })
let entryItemIsLastValueData = fromData.useDataFormat({ viewPath,
context: 'entry_item',
path: 'isLast',
format: fromFormat.not,
})
let entryActionValueData = fromData.useDataValue({ viewPath,
context: 'entry',
path: 'action',
})
let constantData = 'NO_SHOW'
let aggregateData = fromAggregate.equals(entryActionValueData, constantData)
let dtSpaceXxxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxxs'
        })
let entryActionValueData1 = fromData.useDataValue({ viewPath,
context: 'entry',
path: 'action',
})
let entryAppointmentTimeValueData = fromData.useDataValue({ viewPath,
context: 'entry',
path: 'appointmentTime',
})
let aggregateData1 = fromHelpers.getTitle(entryActionValueData1, entryAppointmentTimeValueData)
let dtColorsNeutral900 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.900'
        })
let entryUserValueData = fromData.useDataValue({ viewPath,
context: 'entry',
path: 'user',
})
let dtColorsNeutral600 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.600'
        })
let entryTimeValueData = fromData.useDataValue({ viewPath,
context: 'entry',
path: 'time',
})
  return (<React.Fragment
>
<div
  data-testid="Entry.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<div
  data-testid="Entry.Vertical"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical}`}
>
<div
  data-testid="Entry.Vertical:1"
  data-view-path={viewPath}
 style={{'--mt-1-4PFPn': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--w-2-4PFPn': typeof dtSpaceLs === 'number' ? `${dtSpaceLs}px` : dtSpaceLs,'--h-3-4PFPn': typeof dtSpaceLs === 'number' ? `${dtSpaceLs}px` : dtSpaceLs,'--bc-4-4PFPn': dtColorsNeutral200}}
 className={`views-block ${styles.Vertical1}`}
>
<div
  data-testid="Entry.Vertical:2"
  data-view-path={viewPath}
 style={{'--w-2-4PFPn': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--h-3-4PFPn': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--bc-4-4PFPn': dtColorsNeutral400}}
 className={`views-block ${styles.Vertical2}`}
/>
</div>
<fromFlow.When is={entryItemIsLastValueData}>
<div
  data-testid="Entry.Horizontal:1"
  data-view-path={viewPath}
 style={{'--bc-4-4PFPn': dtColorsNeutral400,'--mh-5-4PFPn': aggregateData ? "70px" : "50px"}}
 className={`views-block ${styles.Horizontal1}`}
/>
</fromFlow.When>
</div>
<div
  data-testid="Entry.Vertical:3"
  data-view-path={viewPath}
 style={{'--g-6-4PFPn': typeof dtSpaceXxxs === 'number' ? `${dtSpaceXxxs}px` : dtSpaceXxxs,'--mr-7-4PFPn': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs}}
 className={`views-block ${styles.Vertical3}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 color={dtColorsNeutral900}
 weight="medium"
 whiteSpace="wrap"
 data="entry.action"
 data="entry.appointmentTime"
 aggregate="helpers.js getTitle"
 text={aggregateData1}
/>
<div
  data-testid="Entry.Horizontal:2"
  data-view-path={viewPath}
 style={{'--g-6-4PFPn': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs}}
 className={`views-block ${styles.Horizontal2}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 color={dtColorsNeutral400}
 size="small"
 text="By"
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 size="small"
 color={dtColorsNeutral600}
 data="entry.user"
 text={entryUserValueData}
/>
</div>
<div
  data-testid="Entry.Horizontal:3"
  data-view-path={viewPath}
 style={{'--g-6-4PFPn': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs}}
 className={`views-block ${styles.Horizontal3}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 color={dtColorsNeutral400}
 size="small"
 text="On"
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 size="small"
 color={dtColorsNeutral600}
 data="entry.time"
 text={entryTimeValueData}
/>
</div>
</div>
</div>
{children}
</React.Fragment>)
}